export class ClientStatisticsByYearRequest {
    constructor(
        public clientId: string,
        public startYear: number,
        public endYear: number,
    ) { }
}